export default __webpack_public_path__ + "static/media/american-business.022841c8.jpeg";